import api from '../api';
import { Failure } from '../../entities/Failure';
import { Success } from '../../entities/Success';
import * as yup from 'yup';

/**
 * @typedef {Object} Props
 * @property {number} contractNumber,
 * @property {string} groupId,
 * @property {number} limit,
 */

/**
 * @param {Props} props
 * @returns {Promise<Success | Failure>}
 */
export async function getProductsByGroup(props) {
  try {
    props.limit = props.limit ?? 20;

    const validated = getProductsByGroupSchema.validateSync(props);

    const params = new URLSearchParams();
    params.append('contract_number', validated.contractNumber);
    params.append('limit', validated.limit);

    const { data } = await api.get(
      `/produto/listar-grupo/${validated.groupId}?${params.toString()}`,
    );

    return new Success(data);
  } catch (error) {
    let errorMessage = '';

    if (error instanceof yup.ValidationError) {
      console.error(error.message);
      errorMessage = error.message;
    }

    console.error('[getProductsByGroup] ERROR: ', error);

    return new Failure(errorMessage);
  }
}

const getProductsByGroupSchema = yup.object({
  groupId: yup.string().min(20).required(),
  contractNumber: yup.number().required(),
  limit: yup.number().required(),
});
